import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useNpsContext } from '../contexts/Nps.context';
import { NpsScoreFormValues, npsScoreFormSchema } from '../nps.schema';

const useNpsScoreForm = () => {
  const { handleAnswerLater, handleAnswerScore, isSubmitting } = useNpsContext();

  const form = useForm<NpsScoreFormValues>({
    resolver: zodResolver(npsScoreFormSchema),
    defaultValues: { score: 0 },
  });

  const handleValidSubmit = form.handleSubmit((data) => {
    handleAnswerScore({ score: data.score });
  });

  return {
    control: form.control,
    isSubmitting,
    handleValidSubmit,
    handleAnswerLater,
  };
};

export default useNpsScoreForm;
